import {
  LinkingOptions,
  getPathFromState as getPathFromStateDefault,
} from '@react-navigation/native';
import navigationConfigWeb from './navigationConfig';
// No longer needed, removing the unused import
// import screens from '../config/screens';

/**
 * Configure web-specific deep linking for React Navigation
 * This allows web URLs to be mapped to the correct screens in the app
 */
const linking: LinkingOptions<any> = {
  // Define the URL prefixes for your application
  // You should update these with your actual domain and scheme
  prefixes: [
    'https://geniomd.com',
    'geniocanguru://',
    'http://localhost:4200',
  ],

  config: {
    path: '/',
    // Don't set a fixed initialRouteName - let the router determine based on auth state
    initialRouteName: undefined,

    // Web-specific screen to path mappings generated from all routes
    screens: navigationConfigWeb.screens,
  },

  // Use a simplified getPathFromState implementation
  getPathFromState: (state, options) => {
    try {
      // First try the default implementation
      let path = getPathFromStateDefault(state, options);

      // Preserve UNID parameter if it exists
      if (typeof window !== 'undefined') {
        const searchParams = new URLSearchParams(window.location.search);
        const unid = searchParams.get('unid');
        if (unid) {
          path = path.includes('?')
            ? `${path}&unid=${unid}`
            : `${path}?unid=${unid}`;
        }
      }

      return path;
    } catch (e) {
      // If there's an error, fallback to a simple implementation
      if (!state?.routes?.length || state.index === undefined) {
        return '';
      }

      const routeName = state.routes[state.index]?.name;
      if (!routeName) return '';

      // Use index signature for TypeScript
      const screensConfig = options?.screens || {};
      const path = (screensConfig as Record<string, string>)[routeName];

      // Return the path or fallback to route name
      let result = typeof path === 'string' ? path : routeName;

      // Preserve UNID parameter if it exists
      if (typeof window !== 'undefined') {
        const searchParams = new URLSearchParams(window.location.search);
        const unid = searchParams.get('unid');
        if (unid) {
          result = result.includes('?')
            ? `${result}&unid=${unid}`
            : `${result}?unid=${unid}`;
        }
      }

      return result;
    }
  },
};

export default linking;
